import * as React from "react";
import { ArrowRight, Mic, AudioLines, Sliders } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const servicesData = [{
  title: "Tracking & Capture",
  description: "Pristine audio capture in our acoustically treated live rooms. We use world-class preamps and microphones to ensure every nuance of your performance is preserved.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/studio_tracking_session.png",
  icon: Mic,
  link: "/ServicesPage"
}, {
  title: "Vocal Tuning & Edit",
  description: "Precision pitch correction and timing alignment that maintains the natural character of your voice while achieving radio-ready perfection and clarity.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/vocal_tuning_suite.png",
  icon: AudioLines,
  link: "/ServicesPage"
}, {
  title: "Mixing & Mastering",
  description: "The final polish your music deserves. Our engineers blend technical precision with artistic vision to create a powerful, balanced, and immersive sonic experience.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/mixing_mastering_desk.png",
  icon: Sliders,
  link: "/ServicesPage"
}];
export default function Services() {
  return <section data-section-id="245009" id="your-sound-refined" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center mb-12 md:mb-16">
          <Badge variant="secondary" className="mb-4 bg-primary/20 text-primary border-primary/30 font-mono uppercase tracking-widest">
            Sonic Excellence
          </Badge>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 tracking-tight">
            Your Sound, Refined
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            PulseWave Studios combines cutting-edge digital workflows with legendary analog warmth to help independent artists and bands achieve professional high-fidelity results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => <Card key={index} data-index={index} className="flex flex-col overflow-hidden border-border bg-card/50 backdrop-blur-sm shadow-lg hover:shadow-primary/10 transition-all duration-500 group rounded-2xl">
              <AspectRatio ratio={16 / 9}>
                <img src={service.image} data-wvc-srcset={`${service.image}-wvc-srcset`} data-wvc-sizes={`${service.image}-wvc-sizes`} alt={service.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110" loading="lazy" />
              </AspectRatio>
              <CardHeader className="pb-4">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary mb-4 shadow-[0_0_15px_rgba(0,255,255,0.2)]">
                  <service.icon className="w-6 h-6" />
                </div>
                <CardTitle className="font-default text-xl font-bold tracking-tight">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow pb-6">
                <p className="text-muted-foreground leading-relaxed font-default">
                  {service.description}
                </p>
              </CardContent>
              <CardFooter className="pt-0 mt-auto">
                <Button asChild variant="outline" className="w-full group border-primary/20 hover:bg-primary hover:text-primary-foreground rounded-full transition-colors">
                  <Link to={service.link}>
                    Explore Service
                    <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>

        <div className="mt-12 text-center">
          <Button asChild size="lg" className="px-8 bg-primary text-primary-foreground hover:opacity-90 rounded-full shadow-[0_0_20px_rgba(0,255,255,0.3)] transition-all">
            <Link to="/ServicesPage">
              View All Studio Services
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}